import { IEntity, Entity, IEntityType, EntityStringId } from 'app/types/entity';
import vmClient from 'app/services/vmClient';
import { DateMarshaller } from './Date';
import { Duration, DurationMarshaller } from './Duration';

export interface ILessonBookingSummary extends IEntity {
  attributes: {
    id: EntityStringId;
    firstStudentJoin: Date | null;
    firstTeacherJoin: Date | null;
    lessonUnlock: Date | null;
    lessonLock: Date | null;
    studentDisconnectCount: number | null;
    teacherDisconnectCount: number | null;
    studentPresenceTime: Duration | null;
    teacherPresenceTime: Duration | null;
    updatedAt: Date;
  }
}

const lessonSummarySchema = {
  typeName: 'LessonBookingSummary',
  version: 3,
  persisted: true,

  attributes: {
    firstStudentJoin: {
      type: Date,
      marshaller: DateMarshaller,
    },
    firstTeacherJoin: {
      type: Date,
      marshaller: DateMarshaller,
    },
    lessonUnlock: {
      type: Date,
      marshaller: DateMarshaller,
    },
    lessonLock: {
      type: Date,
      marshaller: DateMarshaller,
    },
    studentDisconnectCount: { type: 'number' },
    teacherDisconnectCount: { type: 'number' },
    studentPresenceTime: { type: Duration, marshaller: DurationMarshaller },
    teacherPresenceTime: { type: Duration, marshaller: DurationMarshaller },
    updatedAt: {
      type: Date,
      marshaller: DateMarshaller,
      notNull: true,
    },
  },
};

export type LessonBookingSummary = Entity<ILessonBookingSummary>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LessonBookingSummary: IEntityType<ILessonBookingSummary> = vmClient.defineClass(lessonSummarySchema);
